import { Controller } from "@hotwired/stimulus"

const HEX = /^#[0-9a-f]{6}$/i

// Keeps <input type="color"> (not submitted) and the submitted #RRGGBB text field in sync.
export default class extends Controller {
  static targets = ["picker", "text"]

  connect() {
    this.type()
  }

  pick() {
    this.textTarget.value = this.pickerTarget.value.toUpperCase()
    this.textTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  type() {
    const value = this.textTarget.value.trim()
    if (HEX.test(value)) this.pickerTarget.value = value.toLowerCase()
  }
}
